var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconNotCompleted = function SvgIconNotCompleted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#E0E7EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8333 21.9167C27.7873 21.9167 27.75 21.9541 27.75 22.0001C27.75 22.0461 27.7873 22.0834 27.8333 22.0834C27.8794 22.0834 27.9167 22.0461 27.9167 22.0001C27.9167 21.9541 27.8794 21.9167 27.8333 21.9167ZM26.25 22.0001C26.25 21.1256 26.9589 20.4167 27.8333 20.4167C28.7078 20.4167 29.4167 21.1256 29.4167 22.0001C29.4167 22.8745 28.7078 23.5834 27.8333 23.5834C26.9589 23.5834 26.25 22.8745 26.25 22.0001Z",
    fill: "#4A5365"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9993 21.9167C21.9533 21.9167 21.916 21.9541 21.916 22.0001C21.916 22.0461 21.9533 22.0834 21.9993 22.0834C22.0454 22.0834 22.0827 22.0461 22.0827 22.0001C22.0827 21.9541 22.0454 21.9167 21.9993 21.9167ZM20.416 22.0001C20.416 21.1256 21.1249 20.4167 21.9993 20.4167C22.8738 20.4167 23.5827 21.1256 23.5827 22.0001C23.5827 22.8745 22.8738 23.5834 21.9993 23.5834C21.1249 23.5834 20.416 22.8745 20.416 22.0001Z",
    fill: "#4A5365"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1673 21.9167C16.1213 21.9167 16.084 21.9541 16.084 22.0001C16.084 22.0461 16.1213 22.0834 16.1673 22.0834C16.2133 22.0834 16.2507 22.0461 16.2507 22.0001C16.2507 21.9541 16.2133 21.9167 16.1673 21.9167ZM14.584 22.0001C14.584 21.1256 15.2929 20.4167 16.1673 20.4167C17.0418 20.4167 17.7507 21.1256 17.7507 22.0001C17.7507 22.8745 17.0418 23.5834 16.1673 23.5834C15.2929 23.5834 14.584 22.8745 14.584 22.0001Z",
    fill: "#4A5365"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNotCompleted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconNotCompleted.3e953014.svg";
export { ForwardRef as ReactComponent };